import { render, staticRenderFns } from "./GlassBreakageRoomDamagesCauseQuestion.vue?vue&type=template&id=913f8676&scoped=true"
import script from "./GlassBreakageRoomDamagesCauseQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassBreakageRoomDamagesCauseQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GlassBreakageRoomDamagesCauseQuestion.vue?vue&type=style&index=0&id=913f8676&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913f8676",
  null
  
)

export default component.exports